export default "__VITE_ASSET__8f8d0649__"